import baseScmService from './baseScmService';

const superBatchService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    searchSuperBatchesGroup: build.query({
      query: ({ keyword, batchTypes, excludedIds = [] }) => ({
        method: 'GET',
        url: '/super-batch-groups/search/',
        params: {
          q: keyword,
          batch_types: batchTypes,
          excluded_ids: excludedIds.join(','),
        },
      }),
    }),
    searchSuperBatches: build.query({
      query: ({
        keyword,
        batchTypes,
        excludedIds = [],
        superBatchGroupId,
      }) => ({
        method: 'GET',
        url: '/super-batches/search/',
        params: {
          q: keyword,
          batch_types: batchTypes,
          super_batch_group_ids: superBatchGroupId,
          excluded_ids: excludedIds.join(','),
        },
      }),
    }),
    bulkSearchSuperBatches: build.mutation({
      query: ({ batchNames, batchTypes, excludedIds = [] }) => ({
        method: 'POST',
        url: '/super-batches/bulk-search',
        body: {
          batch_names: batchNames,
          batch_types: batchTypes,
          excluded_ids: excludedIds.join(','),
        },
      }),
    }),
    updateMeta: build.mutation({
      query: ({ superBatchIds = [], updates = [] }) => ({
        method: 'POST',
        url: '/super-batches/update-meta',
        body: {
          super_batch_ids: superBatchIds,
          updates: updates,
        },
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useLazySearchSuperBatchesQuery,
  useBulkSearchSuperBatchesMutation,
  useLazySearchSuperBatchesGroupQuery,
  useUpdateMetaMutation,
} = superBatchService;

export default superBatchService;
